import React from 'react'
import "./herocomp.css"

export default function HeroComp(props) {
    return (
        <>
            <div className="hero-sec">
                <div className="masks">
                    <img className="hero-img" src={props.src} alt="hero image" />
                </div>
                <div className="heading">
                    <h1>{props.heading}</h1>
                    <p>{props.paragraph}</p>
                </div>
            </div>
        </>
    )
}
